module.exports = __webpack_public_path__ + "img/thumb_up.d22235cb.svg";